import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import Label from '../Label/Label';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import { makeValidators } from '../helpers';
import './RadioGroup.scss';

const { block } = bem('hook-form-radio-group');

function RadioGroup(props) {
  const { name, label, labelProps = {}, optional, className, inline, reverse, onChange, children, flex } = props;
  const {
    formState: { errors },
  } = useFormContext();
  const intl = useIntl();

  const validators = makeValidators(props, intl);
  const hasError = Object.keys(errors).includes(name);

  const clonedChildren = React.Children.map(children, child =>
    React.cloneElement(child, {
      name,
      validators,
      inline,
      flex,
      reverse,
      hasError,
      onChange,
    })
  );

  return (
    <div className={block({ flex }, className)}>
      <Label name={name} message={label} optional={optional} {...labelProps} />
      {clonedChildren}
      <ErrorMessage name={name} errors={errors} />
    </div>
  );
}

RadioGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  inline: PropTypes.bool,
  flex: PropTypes.bool,
  label: intlMessage,
  labelProps: PropTypes.shape({}),
  name: PropTypes.string,
  onChange: PropTypes.func,
  optional: PropTypes.bool,
  reverse: PropTypes.bool,
};

export default RadioGroup;
